import { render, staticRenderFns } from "./zhiyuan.vue?vue&type=template&id=19fe6ce7&"
var script = {}
import style0 from "./zhiyuan.vue?vue&type=style&index=0&id=19fe6ce7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports